import { type Scalars } from 'cms/cms-types';
import { format } from 'date-fns';
import { TZDate } from '@date-fns/tz';

export const resolveDate = (value: Scalars['Date']): string | undefined => {
    if (!value) {
        return undefined;
    }

    // Normalize CMS date value and format it in the Australia/Sydney timezone.
    const dateValue = typeof value === 'object' && 'input' in value ? value.input : value;

    // we need to display the date in the Australia/Sydney timezone
    const sydneyDate = new TZDate(dateValue, 'Australia/Sydney');

    // format the date in 'd MMM yyyy'
    return format(sydneyDate, 'd MMM yyyy');
};
